/**
    Rotates a point around a given origin.
    @param p The point to be rotated, which should always be an `[x, y]` formatted Array.
    @param alpha The angle in radians to rotate.
    @param origin The origin point of the rotation, which should always be an `[x, y]` formatted Array.
*/ export default function(p, alpha) {
    var origin = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [
        0,
        0
    ];
    var cosAlpha = Math.cos(alpha), sinAlpha = Math.sin(alpha), xshifted = p[0] - origin[0], yshifted = p[1] - origin[1];
    return [
        cosAlpha * xshifted - sinAlpha * yshifted + origin[0],
        sinAlpha * xshifted + cosAlpha * yshifted + origin[1]
    ];
}

//# sourceMappingURL=pointRotate.js.map